<template>
    <div class="content-box">
            <section class="section" style="max-width: 100%;font-size: 14px;line-height: 30px;visibility: visible;">
        <section style="margin-left: 16px;max-width: 100%;outline: 0px;visibility: visible;">
            <p
                style="margin-top: 0px;margin-bottom: 0px;max-width: 100%;clear: both;min-height: 1em;outline: 0px;visibility: visible;">
                <span style="max-width: 100%;font-size: 15px;"><span
                        style="max-width: 100%;outline: 0px;color: rgb(53, 53, 53);text-align: left;visibility: visible;">📣📣</span></span>
            </p>
            <p
                style="margin-top: 0px;margin-bottom: 0px;max-width: 100%;clear: both;min-height: 1em;outline: 0px;visibility: visible;">
                <span
                    style="max-width: 100%;outline: 0px;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;letter-spacing: 0.544px;visibility: visible;font-size: 15px;">亲爱的用户，为了能让您更好的阅读小说后续精彩内容，你可以
                    <strong
                        style="max-width: 100%;font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;letter-spacing: 0.544px;"><span
                            style="max-width: 100%;outline: 0px;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;letter-spacing: 0.544px;visibility: visible;color: rgb(217, 33, 66);">置顶公众号，</span></strong></span><span
                    style="max-width: 100%;outline: 0px;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;letter-spacing: 0.544px;visibility: visible;font-size: 15px;">具体步骤如下：</span>
            </p>
        </section>
    </section>
    <img class="rich_pages wxw-img __bg_gif" style="max-width: 100%;
        width: 497px !important;
        display: block;
        height: auto !important;
        visibility: visible !important;
        margin-bottom:20px;" src="../../../static/imgs/640.gif" alt="图片">
    <section class="section" style="max-width: 100%;font-size: 14px;line-height: 30px;visibility: visible;">
        <section style="margin-left: 16px;max-width: 100%;outline: 0px;visibility: visible;">
            <p
                style="margin-top: 0px;margin-bottom: 0px;max-width: 100%;clear: both;min-height: 1em;outline: 0px;visibility: visible;">
                <span style="max-width: 100%;font-size: 15px;"><span
                        style="max-width: 100%;outline: 0px;color: rgb(53, 53, 53);text-align: left;visibility: visible;">📣📣</span></span>
            </p>
            <p
                style="margin-top: 0px;margin-bottom: 0px;max-width: 100%;clear: both;min-height: 1em;outline: 0px;visibility: visible;">
                <span style="max-width: 100%;outline: 0px;font-size: 15px;"><span
                        style="max-width: 100%;outline: 0px;color: rgb(53, 53, 53);text-align: left;visibility: visible;">另外，<span
                            style="max-width: 100%;color: rgb(51, 51, 51);letter-spacing: 0.544px;text-align: justify;outline: 0px;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;visibility: visible;">也可以去我们公众号的「</span><span
                            style="max-width: 100%;color: rgb(51, 51, 51);letter-spacing: 0.544px;text-align: justify;"><strong
                                style="max-width: 100%;"><span
                                    style="max-width: 100%;outline: 0px;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;letter-spacing: 0.544px;visibility: visible;color: rgb(217, 33, 66);">设置
                                    -&gt;消息免打扰</span></strong></span><span
                            style="max-width: 100%;color: rgb(51, 51, 51);letter-spacing: 0.544px;text-align: justify;outline: 0px;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;visibility: visible;">」里，</span><span
                            style="max-width: 100%;color: rgb(51, 51, 51);letter-spacing: 0.544px;text-align: justify;"><strong
                                style="max-width: 100%;"><span
                                    style="max-width: 100%;outline: 0px;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;letter-spacing: 0.544px;visibility: visible;color: rgb(217, 33, 66);">开启提醒</span></strong></span><span
                            style="max-width: 100%;color: rgb(51, 51, 51);letter-spacing: 0.544px;text-align: justify;outline: 0px;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;visibility: visible;">，这样</span></span></span><span
                    style="max-width: 100%;outline: 0px;font-size: 15px;"><span
                        style="max-width: 100%;outline: 0px;color: rgb(53, 53, 53);text-align: left;visibility: visible;">也可以及时</span></span><span
                    style="max-width: 100%;font-size: 15px;"><strong style="max-width: 100%;"><span
                            style="max-width: 100%;outline: 0px;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;letter-spacing: 0.544px;visibility: visible;color: rgb(217, 33, 66);">接收新消息</span></strong></span><span
                    style="max-width: 100%;outline: 0px;font-size: 15px;"><span
                        style="max-width: 100%;outline: 0px;color: rgb(53, 53, 53);text-align: left;visibility: visible;">哦</span></span><span
                    style="max-width: 100%;font-family: -apple-system-font, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;font-size: 15px;letter-spacing: 0.544px;">，具体步骤如下：</span>
            </p>
        </section>
    </section>
    <img class="rich_pages wxw-img __bg_gif" style="max-width: 100%;
        width: 497px !important;
        display: block;
        height: auto !important;
        visibility: visible !important;
        margin-bottom:20px;" src="../../../static/imgs/641.gif" alt="图片">
    </div>
</template>
<script>

export default {
    data(){
        return{

        }
    }
}
</script>
<style scoped>
.content-box{
        padding: calc(20px + env(safe-area-inset-top)) calc(20px + env(safe-area-inset-right)) 0 calc(20px + env(safe-area-inset-left));
}
 .rich_media_content * {
        max-width: 100% !important;
        box-sizing: border-box !important;
        -webkit-box-sizing: border-box !important;
        word-wrap: break-word !important;
    }

    .section {
        outline: 0px;
        border-style: solid;
        border-image: url(../../../static/imgs/640.png) 94 170 140 fill;
        border-width: 20px 32px 40px 24px;
        font-size: 14px;
        line-height: 30px;
        visibility: visible;
        /* background: url(./imgs/640.png) no-repeat;
        background-size: cover;
    padding: 20px 32px 40px 24px; */
    }

    body {
        padding: calc(20px + env(safe-area-inset-top)) calc(20px + env(safe-area-inset-right)) 0 calc(20px + env(safe-area-inset-left));
    }
</style>



// WEBPACK FOOTER //
// src/view/wxHtml/wxContent.vue